const requests = {
    fetchGuild : {
        url: '/guilds/profile',
        method: 'get',
        params: { 
            region: 'eu', 
            realm: 'zuljin', 
            name: 'Amentibus Cultui', 
            fields: 'members,raid_progression,raid_rankings' },
        onSuccess: (response) => {
            console.log("Success", response.data);
        }
    },
    fetchPlayer : {
        url: '/characters/profile',
        method: 'get',
        params: (region, realm, name) => ({
            region: region,
            realm: realm,
            name: name,
            fields: 'gear,guild,covenant,raid_progression,%20mythic_plus_scores_by_season,mythic_plus_scores_by_season%3Acurrent'
        }),
        onSuccess: (response) => {
            console.log("Success", response.data);
        }
    },
}

export default requests;